import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';

import Layout from 'Global/Layout';
import SEO from 'Global/SEO';
import Hero from 'Global/Hero/Hero';
import OverlapSection from 'Component/OverlapSection/OverlapSection';
import TwoColumnSection from 'Component/TwoColumnSection/TwoColumnSection';
import CtaSection from 'Component/CtaSection/CtaSection';
import TextContent from 'Component/TextContent/TextContent';
import Partners from 'Component/Partners/Partners';

import IconsData from 'IconsData/CorporateDeposits.json';
import TwoColumnData from 'TwoColumnData/CorporateDeposits.json';
import TextContentData from 'TextContentData/CorporateDeposits/CorporateDeposits.json';

const CorporateFD = () => {
	const images = useStaticQuery(IMAGES_QUERY);

	return (
		<Layout>
			<SEO title="Corporate Fixed Deposits" description="" />
			<Hero
				heading="Corporate Fixed Deposits"
				iconsData={IconsData}
				breadcrumbs={[
					{
						text: 'Invest',
						link: '#',
					},
					{
						text: 'Corporate Fixed Deposits',
						link: '#',
					},
				]}
				ctaFormText="Interested in investing in Corporate Fixed Deposits?"
				customClass="bgCorporateFd"
			/>
			<OverlapSection
				heading="What are Corporate Fixed Deposits?"
				description="Typically, when investors wish to park their funds for a fixed term, with low or no risk, they tend to choose the more popular and traditional bank fixed deposit. However, another alternative investment opportunity is presented by corporate fixed deposits offered by non-banking companies and corporates . These are companies who could be operating a variety of businesses, and might be in need of capital for meeting various business needs or goals. When such a need arises, companies issue deposit certificates to investors at fixed interest rates for tenure options which an investor can choose. These are also popular as company fixed deposits among many investors looking for a safe haven for investing their savings."
			/>
			<CtaSection
				heading={<>Choose Corporate FDs over Traditional FDs for higher returns.<br/>Invest Now!</>}
				aboutText="Looking for a fixed term investment with tax benefits?"
				aboutTextLink="Explore Bonds."
				aboutTextLinkUrl="/bonds"
			/>
			<TwoColumnSection
				heading="Invest in the best Corporate Deposits with Moneyfront"
				data={TwoColumnData}
				images={images}
			/>
			<TextContent
				heading="Why invest in Corporate Deposits via Moneyfront?"
				data={TextContentData}
				customClass="corporateDeposits"
			/>
			<Partners heading="Our reputed partners provide the best corporate deposit rates in the country" />
			<CtaSection
				heading="Interested in investing in Corporate Deposits?"
				subheading="Share your contact and our analyst will reach out to you"
				customClass="inFooter"
			/>
		</Layout>
	);
};

export default CorporateFD;

const IMAGES_QUERY = graphql`
	{
		# Two Section Column Images
		carefullyCurated: file(
			relativePath: { eq: "corporate-fd/two-column/higher-interest.png" }
		) {
			childImageSharp {
				fixed(width: 400) {
					...GatsbyImageSharpFixed_withWebp_noBase64
				}
			}
		}
		personalisedAdvice: file(
			relativePath: { eq: "corporate-fd/two-column/ticket-size.png" }
		) {
			childImageSharp {
				fixed(width: 400) {
					...GatsbyImageSharpFixed_withWebp_noBase64
				}
			}
		}
		expertSupport: file(
			relativePath: { eq: "corporate-fd/two-column/safer-option.png" }
		) {
			childImageSharp {
				fixed(width: 400) {
					...GatsbyImageSharpFixed_withWebp_noBase64
				}
			}
		}
	}
`;
